module.exports = __webpack_public_path__ + "static/media/image3.5bb1831a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/VipRoom/images/image3.jpg
// module id = 441
// module chunks = 0